import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uploading-status-popover',
  templateUrl: './uploading-status-popover.component.html',
  styleUrls: ['./uploading-status-popover.component.scss'],
})
export class UploadingStatusPopoverComponent implements OnInit {

  public option: string;

  constructor() { }

  ngOnInit() {}

}
